/* eslint-disable  */
import React, { Component, useState, useEffect } from 'react'
import GetContentsList from '../../Services/Queries/GetContentsList'
import PublishContent2Point0 from '../../Services/Mutations/PublishContent2Point0'
import DeleteContent from '../../Services/Mutations/DeleteContent'
import GetContent from '../../Services/Queries/GetContent'
import { Link } from 'react-router-dom'
import { Button, Modal, Table } from 'react-bootstrap'
import { Auth } from 'aws-amplify'
import ReactReadMoreReadLess from 'react-read-more-read-less'
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import { DateRangePicker } from 'react-date-range'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import _ from 'lodash'
import AwsConfig from '../../Config/AwsConfig'
import DeleteContentInSingleLanguage from '../../Services/Mutations/DeleteContentInSingleLanguage'
import GetUserPermissions from '../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../Constants/Permissions'
import { unPublishedContentsHeadings } from '../Data/StaticData'
import Header from '../header'
import Spinner from '../header/Spinner'
import DuplicateContentForm from './DuplicateContentForm'
import EditTitleUnpublished from './EditTitleUnpublished'
import EditDescUnpublished from './EditDescUnpublished'
const styles = {
  fontSize: {
    fontSize: '12px',
  },
}

class UnPublishedContentsList extends React.Component {
  toastStyle = {
    position: 'top-right',
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }

  constructor(props) {
    super(props)

    this.state = {
      filtered: false,
      selectionRange: {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
      showDatePicker: false,
      error: false,
      unPublishedContentsList: [],
      limit: 100,
      nextToken: null,
      render: false,
      endReached: false,
      loadMore: false,
      props,
      userDetails: {},
      userPermissions: [],
      contentSelectedLang: null,
      currentPage: 1,
      headings: unPublishedContentsHeadings,
      deleteModalVisible: false,
      selectedContentId: '',
      approveModalVisible: false,
      selectedContentLanguages: [],
      displayContents: [
        'Story',
        'ShortByte',
        'CoverStory',
        'Mcq',
        'Poll',
        'SlideShow',
        'liveCricketScore',
        'cricketPointsTable',
        'liveNews',
      ],
      contentsTypes: [
        'Story',
        'ShortByte',
        'CoverStory',
        'Mcq',
        'Poll',
        'SlideShow',
        'liveCricketScore',
        'cricketPointsTable',
        'liveNews',
      ],
      loggedInUserPermissions: [],
      loggedInUserID: '',
      appLanguage: '',
      loading: false,
      editpopup: false,
      editDescPopup: false,
      editingIndexDesc: '',
      Title: '',
      editedArray: [],
      editingIndex: '',
      changedTitle: '',
      pop: false,
      editedTitle: '',
      unpublishedContentsListdata: [],
    }

    this.loadMore = this.loadMore.bind(this)
  }

  loadMore = async () => {
    await this.getNextQuestionsList()
  }

  getUnpublishedContentsList = async () => {
    this.setState({ loading: true })
    const { limit } = this.state
    const input = {
      limit,
      nextToken: null,
      contentStatus: 'draft',
      appInfoFrontEnd: {
        appVersionNumber: 60,
      },
      language: this.state.appLanguage,
    }
    console.log(input, 'input firstt========')
    const unPublishedContentsList = await GetContentsList(input)
    this.setState({ unpublishedContentsListdata: unPublishedContentsList })

    console.log(unPublishedContentsList, 'unPublishedContentsList=====')
    const permissionInput = {
      mobileNumber: Auth.user.attributes.phone_number,
    }
    console.log(permissionInput, 'permissionInput')
    const userPermissions = await GetUserPermissions(permissionInput)
    console.log(userPermissions, 'userPermissions')
    const permissions = []
    const permissionsArr = []
    if (userPermissions && userPermissions.userRolesAndPermissions) {
      userPermissions.userRolesAndPermissions.map((item, index) => {
        permissions.push(...item.permissions)
      })
      permissions.map(permission => {
        permissionsArr.push(permission.name)
      })
    }

    console.log(permissionsArr, 'permissionsArr')

    this.setState({
      loggedInUserID: userPermissions.PK,
      nextToken: unPublishedContentsList.nextToken,
      unPublishedContentsList: unPublishedContentsList.items,
      loggedInUserPermissions: permissionsArr,
      loading: false,
    })
  }

  getNextQuestionsList = async () => {
    const { limit, filtered } = this.state
    const input = {
      limit,
      nextToken: this.state.nextToken,
      contentStatus: 'draft',
      appInfoFrontEnd: {
        appVersionNumber: 60,
      },
      language: this.state.appLanguage,
    }
    if (filtered) {
      const { selectionRange, limit } = this.state
      const epochStartTime = selectionRange.startDate.getTime()
      const epochEndTime = selectionRange.endDate.getTime()
      const startTime = Math.trunc(epochStartTime / 1000)
      const endTime = Math.trunc(epochEndTime / 1000)
      input.fromTime = startTime
      input.toTime = endTime
    }

    console.log(input, 'inputttttttnextttttttt')
    const data = await GetContentsList(input)
    console.log(data.items, 'next dataaaaaaaaaaaaaaaaaaaa')
    if (data.nextToken == null) {
      this.setState({
        unPublishedContentsList: [...this.state.unPublishedContentsList, ...data.items],
        nextToken: null,
      })
    } else {
      this.setState({
        unPublishedContentsList: [...this.state.unPublishedContentsList, ...data.items],
        nextToken: data.nextToken,
      })
    }
  }

  openDeleteModal = item => {
    this.setState({
      selectedContentId: item,
      deleteModalVisible: true,
    })
  }

  closeDeleteModal = item => {
    this.setState({
      selectedContentId: '',
      deleteModalVisible: false,
    })
  }

  openApproveModal = async item => {
    const input = {
      contentID: item.PK,
      loggedInUserID: Auth.user.username,
      appInfoFrontEnd: {
        appVersionNumber: 62,
      },
    }

    const data = await GetContent(input)
    this.setState({ selectedContentId: data, approveModalVisible: true })
  }

  closeApproveModal = item => {
    this.setState({ selectedContentId: '', approveModalVisible: false })
  }

  handleDelete = async () => {
    console.log(this.state.selectedContentLanguages, 'selectedContentLanguages')
    console.log(this.state.selectedContentId.contentLanguages, 'selectedContentId.contentLanguages')
    const item = this.state.selectedContentId
    this.setState({ deleteModalVisible: false })

    if (
      this.state.selectedContentId.contentLanguages.length == 1 ||
      this.state.selectedContentId.contentLanguages.length ==
        this.state.selectedContentLanguages.length
    ) {
      const input = { contentID: item.PK }
      console.log(input, 'input')
      const data = await DeleteContent(input)

      if (data.statusCode == 'A185') {
        const refreshContentsList = this.state.unPublishedContentsList.filter(
          data => data.PK != item.PK,
        )

        this.setState({ unPublishedContentsList: refreshContentsList })
        toast.success('Content Deleted Successfully', this.toastStyle)
      } else {
        toast.error('Failed to delete content', this.toastStyle)
      }
    } else {
      const input = {
        contentID: item.PK,
        language: this.state.selectedContentLanguages[0],
      }
      console.log(input, 'inputinput')

      const data = await DeleteContentInSingleLanguage(input)
      console.log(data, 'datadata')
      if (data.statusCode == 'A296') {
        const index = this.state.unPublishedContentsList.findIndex(data => data.PK == item.PK)
        let deletedLang
        if (this.state.selectedContentLanguages[0] == 'English') {
          deletedLang = 'En'
        } else {
          deletedLang = 'Te'
        }

        let selectedIdContentLangs = this.state.unPublishedContentsList[index].contentLanguages
        selectedIdContentLangs = selectedIdContentLangs.filter(lang => lang !== deletedLang)

        this.state.unPublishedContentsList[
          index
        ].contentLanguages = this.state.unPublishedContentsList[index].contentLanguages.reverse()
        this.setState({
          unPublishedContentsList: this.state.unPublishedContentsList,
        })
        toast.success('Content Deleted Successfully', this.toastStyle)
      } else {
        toast.error('Failed to delete content', this.toastStyle)
      }
    }
  }

  handleApprove = async () => {
    const { selectedContentLanguages, selectedContentId } = this.state
    console.log(selectedContentId, 'selectedContentId')

    const input = {
      PK: selectedContentId.PK,
      SK: selectedContentId.SK,
      approveContentInLanguages: selectedContentLanguages,
      appInfoFrontEnd: {
        UUID: Auth.user.username,
        appVersionNumber: 62,
      },
      contentPublishedBy: this.state.loggedInUserID,
    }
    console.log(input, 'input')
    this.setState({ approveModalVisible: false, selectedContentLanguages: [] })
    const publishContentResponse = await PublishContent2Point0(input)
    if (publishContentResponse.statusCode == 'A270') {
      toast.success('Content Approved Successfully', this.toastStyle)

      this.refreshContents(selectedContentId.PK, selectedContentLanguages)
    } else {
      toast.error('Failed To Approve Content', this.toastStyle)
    }
  }

  refreshContents = (contentID, selectedContentLanguages) => {
    const currentTime = Math.floor(Date.now() / 1000)
    const index = this.state.unPublishedContentsList.findIndex(item => item.contentID == contentID)
    let refreshContentsList = this.state.unPublishedContentsList
    if (this.state.unPublishedContentsList[index].approvedContentLanguages != null) {
      this.state.unPublishedContentsList[index].approvedContentLanguages.push(
        ...selectedContentLanguages,
      )
    } else {
      this.state.unPublishedContentsList[index].approvedContentLanguages = selectedContentLanguages
    }

    if (this.state.unPublishedContentsList[index].scheduledTime > currentTime) {
      this.state.unPublishedContentsList[index].isScheduled = true
    }

    if (
      _.isEqual(
        _.sortBy(this.state.unPublishedContentsList[index].approvedContentLanguages),
        _.sortBy(this.state.unPublishedContentsList[index].contentLanguages),
      ) &&
      this.state.unPublishedContentsList[index].scheduledTime < currentTime
    ) {
      refreshContentsList = this.state.unPublishedContentsList.filter(data => data.PK != contentID)
    }

    this.setState({ unPublishedContentsList: refreshContentsList })
  }

  handleLanguage = selectedlang => {
    const { selectedContentLanguages } = this.state
    const selectedLangIndex = selectedContentLanguages.findIndex(lang => lang == selectedlang)

    if (selectedContentLanguages.includes(selectedlang)) {
      selectedContentLanguages.splice(selectedLangIndex, 1)
    } else {
      selectedContentLanguages.push(selectedlang)
    }

    this.setState({ selectedContentLanguages })
  }

  buttonVisibilityFunc = () => {
    const { selectedContentLanguages } = this.state
    const { approvedContentLanguages } = this.state.selectedContentId
    const checkContentInMultipleLanguage = Boolean(
      this.state.selectedContentId.contentLanguages &&
        this.state.selectedContentId.contentLanguages.length > 1,
    )
    if (checkContentInMultipleLanguage) {
      const teluguContentApproved = Boolean(
        approvedContentLanguages && approvedContentLanguages.includes('Te'),
      )
      const checkTeluguSelected = Boolean(selectedContentLanguages.includes('Te'))
      return teluguContentApproved ? selectedContentLanguages.length : checkTeluguSelected
    }

    return selectedContentLanguages.length
  }

  changeAppLanguage = async e => {
    const { appLanguage } = this.state
    console.log(e, 'eeeeeeeeeee')
    console.log(e.target.value, 'e.target.value')
    const language = e.target.value
    if (language && appLanguage != language) {
      this.setState({ appLanguage: language }, async () => {
        console.log('in list pn counterssssss')
        await this.getUnpublishedContentsList()
      })
      localStorage.setItem('appLanguage', language)
    }
  }

  componentDidMount = async () => {
    let appLanguage = localStorage.getItem('appLanguage')
    appLanguage = appLanguage ? appLanguage : 'Telugu'
    console.log(appLanguage, 'appLanguage')
    this.setState({ appLanguage }, async () => {
      await this.getUnpublishedContentsList()
    })
  }

  renderDeleteConfirmationModal = () => {
    const { deleteModalVisible, selectedContentLanguages } = this.state
    return (
      <Modal show={deleteModalVisible} onHide={() => this.closeDeleteModal()}>
        <Modal.Body>
          <div>
            {this.state.selectedContentId.contentLanguages &&
              this.state.selectedContentId.contentLanguages.length > 1 &&
              this.state.selectedContentId.contentLanguages.map(language => {
                let lang
                if (language == 'En') {
                  lang = 'English'
                } else {
                  lang = 'Telugu'
                }

                return (
                  <div className='row'>
                    <div className='col-md-1'>
                      <input
                        type='checkbox'
                        onClick={() => this.handleLanguage(lang)}
                        checked={selectedContentLanguages.includes(lang)}
                      ></input>
                    </div>
                    <div className='col-md-8'>
                      <text htmlFor='text'> {lang} </text>
                    </div>
                  </div>
                )
              })}
          </div>
          <div className='row'>
            <text>Are you sure you want to delete this content?</text>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.closeDeleteModal()}>Cancel</Button>
          {(this.state.selectedContentId &&
            this.state.selectedContentId.contentLanguages.length == 1) ||
          this.state.selectedContentLanguages.length > 0 ? (
            <Button onClick={() => this.handleDelete()}>Ok</Button>
          ) : (
            <Button disabled variant='secondary'>
              Ok
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    )
  }

  checkContentCreatedInWordpress = () => {
    const { selectedContentId } = this.state
    let isContentInWordPress = false
    if (selectedContentId.contentType == 'Story') {
      isContentInWordPress = Boolean(
        selectedContentId.wordPressInfo &&
          Object.keys(selectedContentId.wordPressInfo).length > 0 &&
          selectedContentId.wordPressInfo.wordPressID,
      )
    }

    return isContentInWordPress
  }

  checkContentHasSocialMedia = () => {
    const { selectedContentId } = this.state
    let isStoryWithSocialMedia = false
    if (selectedContentId.contentType == 'Story') {
      const storyLinkDetails =
        selectedContentId.contentMetaInfo &&
        selectedContentId.contentMetaInfo.storyDetails &&
        selectedContentId.contentMetaInfo.storyDetails.contentNewLinkDetails &&
        selectedContentId.contentMetaInfo.storyDetails.contentNewLinkDetails[0]

      isStoryWithSocialMedia = Boolean(
        (storyLinkDetails && storyLinkDetails.youtubeLink) ||
          (storyLinkDetails && storyLinkDetails.twitterLink) ||
          (storyLinkDetails && storyLinkDetails.instagramLink) ||
          (storyLinkDetails && storyLinkDetails.httpsLink),
      )
    }

    return isStoryWithSocialMedia
  }

  renderApproveConfirmationModal = () => {
    const { approveModalVisible, selectedContentLanguages, selectedContentId } = this.state
    const contentSingleLanguageCondition =
      selectedContentId.contentLanguages &&
      selectedContentId.contentLanguages.length <= 1 &&
      selectedContentLanguages.length > 0

    const isContentInWordPress =
      selectedContentId.contentType == 'Story' ? this.checkContentCreatedInWordpress() : false
    const isStoryWithSocialMedia =
      selectedContentId.contentType == 'Story' ? this.checkContentHasSocialMedia() : false
    return (
      <Modal show={approveModalVisible} onHide={() => this.closeApproveModal()}>
        <Modal.Body>
          {selectedContentId.approvedContentLanguages ? (
            <div className='row'>
              <text>Content Approved In</text>
            </div>
          ) : null}
          {selectedContentId.approvedContentLanguages &&
            selectedContentId.approvedContentLanguages.map(lang => (
              <div className='row'>
                <text>{lang}</text>
              </div>
            ))}
          <div className='row'>
            <text> Approve Content In</text>
          </div>
          <div>
            {this.state.selectedContentId.contentLanguages &&
              this.state.selectedContentId.contentLanguages.map(language => (
                <div>
                  {this.state.selectedContentId.approvedContentLanguages ? (
                    <div>
                      {!this.state.selectedContentId.approvedContentLanguages.includes(language) ? (
                        <div className='row'>
                          <div className='col-md-1'>
                            <input
                              type='checkbox'
                              onClick={() => this.handleLanguage(language)}
                              checked={selectedContentLanguages.includes(language)}
                            ></input>
                          </div>
                          <div className='col-md-8'>
                            <text htmlFor='text'> {language} </text>
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ) : (
                    <div className='row'>
                      <div className='col-md-1'>
                        <input
                          type='checkbox'
                          onClick={() => this.handleLanguage(language)}
                          checked={selectedContentLanguages.includes(language)}
                        ></input>
                      </div>
                      <div className='col-md-8'>
                        <text htmlFor='text'> {language} </text>
                      </div>
                    </div>
                  )}
                </div>
              ))}
          </div>
          <div>
            {isContentInWordPress ? (
              <div>
                <div>
                  <text>This Content Is Also Created In telugu.yousay.tv</text>
                </div>
                {isStoryWithSocialMedia ? (
                  <div>
                    <text>This Content Should Be Manually Published In telugu.yousay.tv</text>
                  </div>
                ) : (
                  <div>
                    <text>This Content Will Also Be Published In telugu.yousay.tv</text>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => this.closeApproveModal()}>Cancel</Button>

          {contentSingleLanguageCondition || this.buttonVisibilityFunc() ? (
            <Button variant='primary' onClick={() => this.handleApprove()}>
              Ok
            </Button>
          ) : (
            <Button disabled variant='secondary'>
              Ok
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    )
  }

  displayFilter = item => {
    const { displayContents } = this.state
    const contentType = item.storyType && item.storyType != '' ? item.storyType : item.contentType

    return displayContents.includes(contentType)
  }

  renderTable = (heading, contentList) => (
    <Table striped bordered hover>
      <thead>
        <tr>
          {heading.map(head => (
            <th className='unpublishedHeader'>{head}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {contentList &&
          contentList.map(
            (row, index) => this.displayFilter(row) && this.renderTableRow(row, index),
          )}
      </tbody>
    </Table>
  )

  getContenttitle = item => {
    let thumbnailTitle = ''

    const {
      storyDetails,
      coverStoryDetails,
      mcqDetails,
      slideShowDetails,
      pollDetails,
      liveCricketDetails,
      cricketPointsTableDetails,
      liveNewsSectionDetails,
    } = item.contentMetaInfo
    const content = item
    const lang = item.contentLanguages.includes('En') ? 'En' : 'Te'
    const contentType = item.storyType && item.storyType != '' ? item.storyType : item.contentType
    console.log(contentType, 'contentType')
    switch (contentType) {
      case 'Story':
      case 'ShortByte':
        thumbnailTitle = storyDetails[`storyTitle_${lang}`]
        break
      case 'Mcq':
        thumbnailTitle = mcqDetails[`mcqTitle_${lang}`]
        break
      case 'Poll':
        thumbnailTitle = pollDetails[`pollTitle_${lang}`]
        break
      case 'liveCricketScore':
        thumbnailTitle = liveCricketDetails && liveCricketDetails[`liveCricketTitle_${lang}`]
        break
      case 'cricketPointsTable':
        thumbnailTitle =
          cricketPointsTableDetails && cricketPointsTableDetails[`cricketPointsTableTitle_${lang}`]
        break
      case 'CoverStory':
        const { flipToStoryDetails, onlyCoverDetails, inAppBrowserDetails } = coverStoryDetails
        switch (coverStoryDetails ? coverStoryDetails.coverStoryType : '') {
          case 'FlipToStory':
            thumbnailTitle = flipToStoryDetails[`coverStoryTitle_${lang}`]
            break
          case 'OnlyCover':
            thumbnailTitle = onlyCoverDetails[`coverStoryTitle_${lang}`]
            break
          case 'InAppBrowser':
            thumbnailTitle = inAppBrowserDetails[`coverStoryTitle_${lang}`]
            break
          default:
            thumbnailTitle = ''
        }

        break
      case 'SlideShow':
        thumbnailTitle = slideShowDetails && slideShowDetails[`slideShowTitle_${lang}`]
        break
      case 'liveNews':
        thumbnailTitle = liveNewsSectionDetails
          ? liveNewsSectionDetails.length > 0
            ? liveNewsSectionDetails[0][`liveNewsTitle_${lang}`]
            : ''
          : ''
        break
      default:
        thumbnailTitle = ''
    }

    return thumbnailTitle
  }

  getContentDescription = item => {
    let thumbnailTitle = ''

    const {
      storyDetails,
      coverStoryDetails,
      mcqDetails,
      slideShowDetails,
      pollDetails,
      liveCricketDetails,
      cricketPointsTableDetails,
      liveNewsSectionDetails,
    } = item.contentMetaInfo
    const content = item
    const lang = item.contentLanguages.includes('En') ? 'En' : 'Te'
    const contentType = item.storyType && item.storyType != '' ? item.storyType : item.contentType

    switch (contentType) {
      case 'Story':
      case 'ShortByte':
        thumbnailTitle = storyDetails[`storyCardDescription_${lang}`]
        break
      case 'Mcq':
        thumbnailTitle = mcqDetails[`explanationCardTitle_${lang}`]
        break
      case 'Poll':
        thumbnailTitle = pollDetails[`pollDescription_${lang}`]
        break
      case 'liveCricketScore':
        thumbnailTitle = liveCricketDetails && liveCricketDetails[`liveCricketDescription_${lang}`]
        break
      case 'cricketPointsTable':
        thumbnailTitle =
          cricketPointsTableDetails &&
          cricketPointsTableDetails[`cricketPointsTableDescription_${lang}`]
        break
      case 'CoverStory':
        const { flipToStoryDetails, onlyCoverDetails, inAppBrowserDetails } = coverStoryDetails
        switch (coverStoryDetails.coverStoryType) {
          case 'FlipToStory':
            thumbnailTitle = flipToStoryDetails[`coverStoryCardDescription_${lang}`]
            break
          case 'OnlyCover':
            thumbnailTitle = onlyCoverDetails[`coverStoryCardDescription_${lang}`]
            break
          case 'InAppBrowser':
            thumbnailTitle = inAppBrowserDetails[`coverStoryCardDescription_${lang}`]
            break
          default:
            thumbnailTitle = ''
        }

        break
      case 'SlideShow':
        thumbnailTitle = ''
        break
      case 'liveNews':
        thumbnailTitle = liveNewsSectionDetails
          ? liveNewsSectionDetails.length > 0
            ? liveNewsSectionDetails[0][`liveNewsDescription_${lang}`]
            : ''
          : ''
        break
      default:
        thumbnailTitle = ''
    }

    return thumbnailTitle
  }

  getContentUri = item => {
    let uri
    const {
      storyDetails,
      coverStoryDetails,
      mcqDetails,
      pollDetails,
      slideShowDetails,
      thumbnailURL,
      cricketPointsTableDetails,
      liveCricketDetails,
      liveNewsSectionDetails,
    } = item.contentMetaInfo
    const cdnurl = AwsConfig.cdn_url
    const contentType = item.storyType && item.storyType != '' ? item.storyType : item.contentType

    switch (contentType) {
      case 'Story':
      case 'ShortByte':
        uri =
          storyDetails.storyCardImages &&
          storyDetails.storyCardImages[0] &&
          storyDetails.storyCardImages[0].image
        if (uri == undefined && storyDetails.youtubeID != '') {
          uri = `https://img.youtube.com/vi/${storyDetails.youtubeID}/default.jpg`
        }

        if (!uri && thumbnailURL) {
          uri = thumbnailURL
          if (uri && !uri.includes(cdnurl)) {
            uri = cdnurl + thumbnailURL
          }
        }

        break
      case 'Mcq':
        uri = mcqDetails.mcqImages && mcqDetails.mcqImages[0] && mcqDetails.mcqImages[0].image
        break
      case 'Poll':
        uri = pollDetails.pollImage && pollDetails.pollImage[0] && pollDetails.pollImage[0].image
        break
      case 'CoverStory':
        const { flipToStoryDetails, onlyCoverDetails, inAppBrowserDetails } = coverStoryDetails
        switch (coverStoryDetails.coverStoryType) {
          case 'FlipToStory':
            uri =
              flipToStoryDetails.coverStoryImages &&
              flipToStoryDetails.coverStoryImages[0] &&
              flipToStoryDetails.coverStoryImages[0].image
            if (uri == undefined && flipToStoryDetails.youtubeID != '') {
              uri = `https://img.youtube.com/vi/${flipToStoryDetails.youtubeID}/default.jpg`
            }

            if (!uri && thumbnailURL) {
              uri = thumbnailURL
              if (uri && !uri.includes(cdnurl)) {
                uri = cdnurl + thumbnailURL
              }
            }

            break
          case 'OnlyCover':
            uri =
              onlyCoverDetails.coverStoryImages &&
              onlyCoverDetails.coverStoryImages[0] &&
              onlyCoverDetails.coverStoryImages[0].image
            if (uri == undefined && onlyCoverDetails.youtubeID != '') {
              uri = `https://img.youtube.com/vi/${onlyCoverDetails.youtubeID}/default.jpg`
            }

            if (!uri && thumbnailURL) {
              uri = thumbnailURL
              if (uri && !uri.includes(cdnurl)) {
                uri = cdnurl + thumbnailURL
              }
            }

            break
          case 'InAppBrowser':
            uri =
              inAppBrowserDetails.coverStoryImages &&
              inAppBrowserDetails.coverStoryImages[0] &&
              inAppBrowserDetails.coverStoryImages[0].image
            break
          default:
            uri = ''
        }

        break
      case 'SlideShow':
        uri = slideShowDetails && slideShowDetails.slideShowImage
        break
      case 'liveCricketScore':
        uri =
          liveCricketDetails &&
          liveCricketDetails.liveCricketImages &&
          liveCricketDetails.liveCricketImages[0] &&
          liveCricketDetails.liveCricketImages[0].image
        if (uri && !uri.includes(cdnurl)) {
          uri = cdnurl + uri
        }

        break
      case 'cricketPointsTable':
        uri =
          cricketPointsTableDetails &&
          cricketPointsTableDetails.cricketPointsTableImages &&
          cricketPointsTableDetails.cricketPointsTableImages[0] &&
          cricketPointsTableDetails.cricketPointsTableImages[0].image
        if (uri && !uri.includes(cdnurl)) {
          uri = cdnurl + uri
        }

        break
      case 'liveNews':
        if (liveNewsSectionDetails) {
          uri =
            liveNewsSectionDetails[0].liveNewsImages &&
            liveNewsSectionDetails[0].liveNewsImages[0] &&
            liveNewsSectionDetails[0].liveNewsImages[0].image
          uri = uri?.includes(cdnurl) ? uri : cdnurl + uri
          if (uri == undefined && liveNewsSectionDetails[0].youtubeID != '') {
            uri = `https://img.youtube.com/vi/${liveNewsSectionDetails[0].youtubeID}/default.jpg`
          }

          if (!uri && thumbnailURL) {
            uri = thumbnailURL
            if (uri && !uri.includes(cdnurl)) {
              uri = cdnurl + thumbnailURL
            }
          }
        } else {
          uri = ''
        }

        break
      default:
        uri = ''
    }

    let image = uri

    console.log(typeof cdnurl, 'type of cdn urllll==========')
    let removedcdnurl = ''
    if (image.includes(cdnurl)) {
      removedcdnurl = image.replaceAll(cdnurl, '')
      console.log(removedcdnurl, 'abcabc')
    }

    image = cdnurl + removedcdnurl
    return image
  }

  getTeamBUri = item => {
    let uri
    const { liveCricketDetails } = item.contentMetaInfo
    const cdnurl = AwsConfig.cdn_url
    const contentType = item.storyType && item.storyType != '' ? item.storyType : item.contentType

    switch (contentType) {
      case 'liveCricketScore':
        uri =
          liveCricketDetails &&
          liveCricketDetails.liveCricketImages &&
          liveCricketDetails.liveCricketImages[1] &&
          liveCricketDetails.liveCricketImages[1].image
        if (uri && !uri.includes(cdnurl)) {
          uri = cdnurl + uri
        }

        break

      default:
        uri = ''
    }

    return uri
  }

  renderTitle = item => {
    let title = ''
    if (item.contentType == 'Story') {
      title = item.contentMetaInfo.storyDetails.storyTitle
    } else if (item.contentType == 'CoverStory') {
      const { coverStoryType } = item.contentMetaInfo.coverStoryDetails
      if (coverStoryType == 'FlipToStory') {
        title = item.contentMetaInfo.coverStoryDetails.flipToStoryDetails.coverStoryTitle
      } else if (coverStoryType == 'OnlyCover') {
        title = item.contentMetaInfo.coverStoryDetails.onlyCoverDetails.coverStoryTitle
      } else if (coverStoryType == 'InAppBrowser') {
        title = item.contentMetaInfo.coverStoryDetails.inAppBrowserDetails.coverStoryTitle
      }
      // title = item.contentMetaInfo.storyDetails.storyTitle
    } else if (item.contentType == 'Mcq') {
      title = item.contentMetaInfo.mcqDetails.mcqTitle
    } else if (item.contentType == 'SlideShow') {
      title = item.contentMetaInfo.slideShowDetails.slideShowTitle
    }

    return <text>{title}</text>
  }

  renderDescription = item => {
    let description = ''
    if (item.contentType == 'Story') {
      description = item.contentMetaInfo.storyDetails.storyCardDescription
    }

    if (item.contentType == 'CoverStory') {
      const { coverStoryType } = item.contentMetaInfo.coverStoryDetails
      if (coverStoryType == 'FlipToStory') {
        description =
          item.contentMetaInfo.coverStoryDetails.flipToStoryDetails.coverStoryCardDescription
      } else if (coverStoryType == 'OnlyCover') {
        description =
          item.contentMetaInfo.coverStoryDetails.onlyCoverDetails.coverStoryCardDescription
      }
    } else if (item.contentType == 'Mcq') {
      description = item.contentMetaInfo.mcqDetails.explanationCardTitle
    }

    return <text>{description}</text>
  }

  getFormattedDate = date => {
    let dd = date.getDate()
    let mm = date.getMonth() + 1

    const yyyy = date.getFullYear()
    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    const formattedDate = dd + '/' + mm + '/' + yyyy
    const hh = date.getHours()
    let m = date.getMinutes()
    let d = 'AM'
    let h = hh
    if (h >= 12) {
      h = hh - 12
      d = 'PM'
    }

    if (h == 0) {
      h = 12
    }

    m = m < 10 ? '0' + m : m
    const formattedTime = h + ':' + m + ' ' + d
    return formattedDate + ' ' + formattedTime
  }

  getPublishedDate = time => {
    const pubDate = new Date(time * 1000)
    const PublishedDate = this.getFormattedDate(pubDate)
    return PublishedDate
  }

  handleSelect = dates => {
    const start = new Date(dates.selection.startDate)
    start.setHours(0, 0, 0, 0)
    const end = new Date(dates.selection.endDate)
    end.setHours(23, 59, 59, 999)

    const dateObj = {
      startDate: start,
      endDate: end,
      key: 'selection',
    }

    this.setState({
      selectionRange: dateObj,
      showDatePicker: false,
      filtered: true,
    })
  }

  openDatePicker = () => {
    this.setState({ showDatePicker: true })
  }

  filterData = async () => {
    const { selectionRange, limit } = this.state
    const epochStartTime = selectionRange.startDate.getTime()
    const epochEndTime = selectionRange.endDate.getTime()
    const startTime = Math.trunc(epochStartTime / 1000)
    const endTime = Math.trunc(epochEndTime / 1000)
    const input = {
      limit,
      nextToken: null,
      fromTime: startTime,
      toTime: endTime,
      contentStatus: 'draft',
      appInfoFrontEnd: {
        appVersionNumber: 60,
      },
      language: this.state.appLanguage,
    }
    console.log(input, 'input firstt========')
    const unPublishedContentsList = await GetContentsList(input)
    console.log(unPublishedContentsList, 'unPublishedContentsList=====')

    this.setState({
      nextToken: unPublishedContentsList.nextToken,
      unPublishedContentsList: unPublishedContentsList.items,
    })
  }

  resetFilter = () => {
    this.setState({
      filtered: false,
      selectionRange: {
        startDate: new Date(),
        endDate: new Date(),
        key: 'selection',
      },
    })
    this.getUnpublishedContentsList()
  }

  displayToast = (type, message) => {
    if (type == 'success') {
      toast.success(message, this.toastStyle)
    } else {
      toast.error(message, this.toastStyle)
    }
  }

  // -----------------

  editpop = () => {
    if (this.pop === true) {
      this.setState({ pop: false })
    } else {
      this.setState({ pop: true })
    }
  }

  //------------

  handleEditTitle = (e, index) => {
    console.log(index, 'edittitleindex')

    console.log(e.target.value, 'newFirstnamenewFirstname')
    this.setState({ Title: e.target.value })
  }

  handlesavetitle = (e, index) => {
    // this.props.onUpdate(this.state);
    this.setState({ editedTitle: e.target.value, editpopup: false })
  }

  handlecanceltitlt = index => {
    console.log('cancel', index)
    this.setState({ editpopup: false })
  }

  //------------------------------
  handleEditDesc = (e, index) => {
    console.log(index, 'editDescindex')

    console.log(e.target.value, 'newFirstnamenewFirstname')
    this.setState({ Desc: e.target.value })
  }

  handlesaveDesc = (e, index) => {
    const { editedArray, Desc } = this.state
    const objvalues = {
      Desc,
      index,
    }

    editedArray.push(objvalues)
    console.log(editedArray, 'editedArrayafterpush')

    e.preventDefault()
    console.log('submit', index)
    console.log(this.state.editingIndex, 'editingIndex====')
    // this.props.onUpdate(this.state);
    this.setState({ editDescPopup: false })
  }

  handlecancelDesc = index => {
    console.log('cancel', index)
    this.setState({ editDescPopup: false })
  }

  renderTableRow = (item, index) => {
    const deleteUnpublishedContents = this.state.loggedInUserPermissions.includes(
      DefinedPermissions.deleteUnpublishedContents,
    )
    const approveUnpublishedContentsPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions.approveUnpublishedContentsPermission,
    )
    const editUnpublishedContentsPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions.editUnpublishedContentsPermission,
    )
    const duplicateContentPermission = this.state.loggedInUserPermissions.includes(
      DefinedPermissions.duplicateContentPermission,
    )
    const currentTime = Math.trunc(new Date().getTime() / 1000)
    const PK = item.PK.replace('cont#', '')
    const isContentInWordPress = Boolean(
      item.wordPressInfo &&
        Object.keys(item.wordPressInfo).length > 0 &&
        item.wordPressInfo.wordPressID,
    )
    let wpPostURL = ''
    if (isContentInWordPress) {
      wpPostURL = item.wordPressInfo.wordPressPostURL
    }

    const contentType = item.storyType && item.storyType != '' ? item.storyType : item.contentType
    // ========
    function popup(status, indexval) {
      if (indexval == index) {
        const customId = 'custom-id-yes'
        console.log(index, 'aaaaa222222index')
        console.log(indexval, 'aaaaindexval')
        switch (status) {
          case 'A186':
            console.log('aaaa2222status22index')

            toast.success('Title Updated Successfully', {
              toastId: 'success1',
            })

            break
          default:
            toast.error('Failed to update Title ')
        }
      }
    }
    console.log(editUnpublishedContentsPermission, 'editUnpublishedContentsPermission')
    return (
      <tr>
        <td style={{ fontSize: '12px', maxWidth: '30px' }}>{index + 1}</td>
        <td>
          <div className='row d-flex justify-content-center align-items-center'>
            {editUnpublishedContentsPermission ? (
              <Link
                data-toggle='tooltip'
                title={'Edit Content'}
                style={styles.fontSize}
                class='col-md-3 faIconClass'
                to={`/editContent?${PK}`}
                target='_blank'
              >
                <i className='fas fa-pencil-alt' />
              </Link>
            ) : null}
            {item.contentType == 'Story' && duplicateContentPermission ? (
              <DuplicateContentForm item={item} displayToast={this.displayToast} />
            ) : null}
            {deleteUnpublishedContents ? (
              <div
                data-toggle='tooltip'
                title={'Delete Content'}
                style={styles.fontSize}
                className='col-md-3 faIconClass'
                onClick={() => {
                  this.openDeleteModal(item)
                }}
              >
                <i className='fas fa-trash' />
              </div>
            ) : null}
            {Auth.user.attributes &&
            Auth.user.attributes.phone_number &&
            approveUnpublishedContentsPermission ? (
              <div
                data-toggle='tooltip'
                title={'Approve Content'}
                style={styles.fontSize}
                className='col-md-3 faIconClass'
                onClick={() => {
                  this.openApproveModal(item)
                }}
              >
                <i className='fas fa-upload' />
              </div>
            ) : null}
          </div>
        </td>
        <td style={{ fontSize: '12px', minWidth: '150px' }}>
          {item.contentCreatedDateTime ? this.getPublishedDate(item.contentCreatedDateTime) : '-'}
        </td>

        <td className='permalinkCellStyle' style={styles.fontSize}>
          {isContentInWordPress ? (
            <a href={`${wpPostURL}&preview=true`} target='_blank' rel='noreferrer'>
              {wpPostURL}
            </a>
          ) : (
            '-'
          )}
        </td>
        <td style={styles.fontSize}>{item.isScheduled ? 'True' : 'False'}</td>
        <td style={styles.fontSize}>
          {contentType != 'liveCricketScore' ? (
            <img style={{ height: '150px' }} src={this.getContentUri(item)} />
          ) : null}
          {contentType == 'liveCricketScore' ? (
            <div className='d-flex justify-content-evenly'>
              <img height='150' style={{ borderRadius: '50%' }} src={this.getContentUri(item)} />
              <img height='150' style={{ borderRadius: '50%' }} src={this.getTeamBUri(item)} />
            </div>
          ) : null}
        </td>
        <td style={{ fontSize: '12px', minWidth: '300px' }}>
          <div style={{ position: 'relative', width: '16rem' }}>
            {this.getContenttitle(item)}
            <EditTitleUnpublished
              popup={popup}
              status='published'
              item={item}
              getUnpublishedContentsList={this.getUnpublishedContentsList}
              title={this.getContenttitle(item)}
              unpublishedContentsListdata={this.state.unpublishedContentsListdata}
              index={index}
            />
          </div>
        </td>
        <td style={{ fontSize: '12px', minWidth: '300px' }}>
          {this.getContentDescription(item) ? (
            <div className='App' style={{ position: 'relative', width: '16rem' }}>
              <ReactReadMoreReadLess
                charLimit={150}
                readMoreText={'Read more ▼'}
                readLessText={'Read less ▲'}
                readMoreClassName='read-more-less--more'
                readLessClassName='read-more-less--less'
              >
                {this.getContentDescription(item)}
              </ReactReadMoreReadLess>
              <div
                style={{
                  display: 'inline',
                  justifyContent: 'spaceBetween',
                }}
              >
                <EditDescUnpublished
                  item={item}
                  getUnpublishedContentsList={this.getUnpublishedContentsList}
                  unpublishedContentsListdata={this.state.unpublishedContentsListdata}
                  description={this.getContentDescription(item)}
                  index={index}
                />
              </div>
            </div>
          ) : null}
        </td>
        <td style={{ minWidth: '150px', fontSize: '12px' }}>
          {item.originalCreatorName ? item.originalCreatorName : '-'}
        </td>
        <td style={{ minWidth: '150px', fontSize: '12px' }}>
          {item.originalCreatorHandle ? item.originalCreatorHandle : '-'}
        </td>

        <td style={styles.fontSize}>{item.likes}</td>

        <td style={styles.fontSize}>{item.viewed}</td>

        <td style={styles.fontSize}>{item.sharedVideoCount}</td>

        <td style={styles.fontSize}>{item.commentsCount}</td>
        <td style={styles.fontSize}>{item.createdFrom}</td>

        <td style={{ fontSize: '12px', minWidth: '300px' }}>{item.PK}</td>
        <td style={styles.fontSize}>
          {item.contentType == 'CoverStory'
            ? item.contentMetaInfo && item.contentMetaInfo.coverStoryDetails
              ? item.contentMetaInfo.coverStoryDetails.coverStoryType
              : item.contentType
            : item.storyType && item.storyType != ''
            ? item.storyType
            : item.contentType}
        </td>

        <td style={styles.fontSize}>{item.contentMainCategory}</td>

        <td style={styles.fontSize}>{item.archivedFromRedis ? 'True' : 'False'}</td>
        <td style={styles.fontSize}>
          {item.contentLanguages ? item.contentLanguages.join(',') : '-'}
        </td>
        <td style={styles.fontSize}>
          {item.approvedContentLanguages ? item.approvedContentLanguages.join(',') : '-'}
        </td>
        <td style={styles.fontSize}>{item.targetAreasV2 ? item.targetAreasV2.join(',') : '-'}</td>

        <td style={{ fontSize: '12px', minWidth: '150px' }}>
          {item.isScheduled && item.scheduledTime ? this.getPublishedDate(item.scheduledTime) : '-'}
        </td>
        <td style={{ fontSize: '12px', minWidth: '150px' }}>
          {item.contentPublishedDateTime
            ? this.getPublishedDate(item.contentPublishedDateTime)
            : '-'}
        </td>
      </tr>
    )
  }

  render() {
    const {
      unPublishedContentsList,
      headings,
      selectionRange,
      showDatePicker,
      loading,
    } = this.state
    return (
      <section className='feed'>
        {loading ? <Spinner /> : null}
        <Header changeAppLanguage={this.changeAppLanguage} appLanguage={this.state.appLanguage} />

        <div>
          <label>UnPublished Contents</label>
        </div>
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {this.state.unPublishedContentsList ? (
          <div>
            <div className='row'>
              <div className='col-md-4'>
                <text>Start Date : </text>
                <input
                  type='text'
                  onClick={() => {
                    this.openDatePicker()
                  }}
                  value={this.getFormattedDate(selectionRange.startDate)}
                  placeholder='Choose Start Date'
                ></input>
              </div>

              <div className='col-md-4'>
                <text>End Date : </text>
                <input
                  type='text'
                  onClick={() => {
                    this.openDatePicker()
                  }}
                  value={this.getFormattedDate(selectionRange.endDate)}
                  placeholder='Choose End Date'
                ></input>
              </div>
              <div className='filter-options'>
                <Button
                  style={{ marginRight: 10 }}
                  onClick={() => {
                    this.filterData()
                  }}
                >
                  Filter
                </Button>
                <Button
                  onClick={() => {
                    this.resetFilter()
                  }}
                >
                  Reset
                </Button>
              </div>
            </div>
            <div>
              {showDatePicker ? (
                <DateRangePicker ranges={[selectionRange]} onChange={this.handleSelect} />
              ) : null}
            </div>
            <div>
              <label>Filter list based on ContentType</label>
              <div>
                {this.state.contentsTypes.map(item => (
                  <div>
                    <input
                      type='checkbox'
                      onClick={() => {
                        if (this.state.displayContents?.includes(item)) {
                          const displayContentsData = this.state.displayContents
                          const newData = displayContentsData.filter(val => val != item)
                          this.setState({ displayContents: newData })
                        } else {
                          const displayContentsData = this.state.displayContents
                          displayContentsData.push(item)
                          this.setState({
                            displayContents: displayContentsData,
                          })
                        }
                      }}
                      checked={this.state.displayContents?.includes(item)}
                    ></input>
                    <text>{item}</text>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ marginTop: 10 }}>
              {this.renderTable(headings, unPublishedContentsList)}
            </div>
          </div>
        ) : (
          <div>No Data To Display</div>
        )}
        {this.renderDeleteConfirmationModal()}
        {this.renderApproveConfirmationModal()}
        {this.state.nextToken != null && (
          <button onClick={this.loadMore} type='button' className='load-more'>
            Load more
          </button>
        )}
      </section>
    )
  }
}

export default UnPublishedContentsList
